<script setup lang="ts">
import { functionFlowSteps } from "~/features/python/ch2/functions/data/functions.content";
</script>

<template>
  <section class="rounded-3xl border border-slate-200 bg-slate-50 p-5 shadow-sm">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Function andar kya karta hai?</h2>
      <p class="text-sm text-slate-600">Step by step dekho ke function kaam kaise karta hai.</p>
    </div>

    <ol class="mt-4 space-y-3">
      <li
        v-for="(step, index) in functionFlowSteps"
        :key="step"
        class="rounded-2xl bg-white p-4 ring-1 ring-slate-200"
      >
        <span class="text-xs font-semibold uppercase tracking-wide text-slate-500">Step {{ index + 1 }}</span>
        <p class="mt-2 text-sm text-slate-700">{{ step }}</p>
      </li>
    </ol>
  </section>
</template>
